import cn from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';

import styles from './index.module.sass';

export function DefaultPageTemplate(props: IHomeTemplateProps) {
  const { className, children, ...rest } = props;
  const rootClass = cn(className, styles.root);

  return (
    <div className={rootClass} {...rest}>
      {children}
    </div>
  );
}

export interface IHomeTemplateProps
  extends PropsWithChildren,
    HTMLAttributes<HTMLDivElement> {}
